import { RADIUS, heightAt } from './terrainGen';

/** Sample the terrain radius at a given direction on the sphere.
 *  Returns the distance from center to the terrain surface. */
export function sampleTerrainRadius(
  nx: number, ny: number, nz: number,
  _oceanRadius?: number, _seed?: number,
): number {
  const h = heightAt(nx, ny, nz);
  return RADIUS * (1.0 + Math.max(h, 0));
}
